module.exports = __webpack_public_path__ + "static/media/AppLogo_white.bed86e3a.jpeg";